import account from '@/request/api/account'
import category from '@/request/api/category'
import show from '@/request/api/show'
import episode from '@/request/api/episode'
import notice from '@/request/api/notice'
import noticeConfig from '@/request/api/config/notice'
import priceItem from '@/request/api/price-item'
import image from '@/request/api/image'
import audio from '@/request/api/audio'
import media from '@/request/api/media'
import user from '@/request/api/user'
import topic from '@/request/api/topic'
import topicConfig from '@/request/api/config/topic'
// import topicConfig from '@/request/api/config/topic'
import topSwipe from '@/request/api/topswipe.js'
import topSwipeConfig from '@/request/api/config/topswipe'
import todayRecommend from '@/request/api/today-recommend.js'
import todayRecommendConfig from '@/request/api/config/today-recommend'
import voucher from '@/request/api/voucher'
import voucherConfig from '@/request/api/config/voucher'


export default {
  account,
  category,
  show,
  episode,
  notice,
  noticeConfig,
  priceItem,
  image,
  audio,
  media,
  user,
  topic,
  topicConfig,
  topSwipe,
  topSwipeConfig,
  todayRecommend,
  todayRecommendConfig,
  voucher,
  voucherConfig
}
